export default __webpack_public_path__ + "7750a3422d2ff0a9e62cb9c83589a2d1.svg";